export const TIME_HEARTBEAT = 1 * 60 * 1000; // Every minute

export const TIME_TOAST_TIMEOUT = 3 * 1000;

export const TIME_SNACKBAR_SHORT = 2200;
export const TIME_SNACKBAR_MEDIUM = 5000;
export const TIME_SNACKBAR_LONG = 6500;
